import { nullableRoomId, roomId } from "./room-id";
import { nullableRoomPid, roomPid } from "./room-pid";

export const roomAnyId = {
  anyOf: [roomId, roomPid]
};
export const nullableRoomAnyId = {
  anyOf: [nullableRoomId, nullableRoomPid]
};
